<h2 mat-dialog-title>Confirmation</h2>
<mat-dialog-content class="mat-typography">
  Are you sure you want to logout?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" (click)="onNoClick()">No</button>
  <button mat-raised-button mat-dialog-close (click)="onYesClick()" 
          style="background-color: #04A251; color: white;" cdkFocusInitial>
    Yes
  </button>
</mat-dialog-actions>

